/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

export const environment = {
  production: true,
  backendServer: 'https://api.touren.verkehrssicherung-hahn.de',
  oAuthClientSecret: '4fbdf2245834b514330891e4a2f6de10865f222e6b50d2538271a6e2d0670cf23027f07f313a093394add3ad972b65287316952b8d39211262f96eeb934f148d',
  oAuthClientId: 'd642061d940748271cad3c03b95f6406',
  headerColor: 'white',
  headerImage: 'assets/img/hahn_logo.png',
  headerAltText: 'Hahn Auf Straßen innovativ GmbH &amp; Co KG',
  releaseHash: 'ab7012b847cf4d6e30043a4f7dd3e55bfb557982',
  language: 'de',
  sentryDsn: 'https://0e4c57006d102e0e4bf3945ab60d0227@o4511767038001152.ingest.de.sentry.io/4511767040032848',
  sentryEnvironment: 'live'
};
